import { Row } from "../../../components/row";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../../components/table";
import { TrendingDown, TrendingUp } from "lucide-react";
import type { ActivityLevelModel } from "../types/LiveEvent";
import type { TargetOpportunityModel } from "../types/TargetOppotunity";

type ActivityLevelTableProps = {
    data: ActivityLevelModel[] | null;
    targetOpportunities: TargetOpportunityModel[] | null;
    maxHeight?: string;
    maxWidth?: string;
    scale?: number;
};

export default function ActivityLevelTable({ data: activityLevels, targetOpportunities, maxHeight = "400px", maxWidth = "100%", scale = 1 }: ActivityLevelTableProps) {
    const getRateGrowth = (organization_population_id: string) => {
        if (targetOpportunities && targetOpportunities.length > 0) {
            let targetOpportunity = targetOpportunities.find(to => to.organization_population_id === organization_population_id);
            if (targetOpportunity && targetOpportunity.growth_rate) {
                return targetOpportunity.growth_rate;
            }
        }
        return 0;
    }

    const renderTrendCell = (growthRate: number) => {
        let trend = "";
        if (growthRate > 0) {
            trend = `+${growthRate.toFixed(1)}%`;
        } else {
            trend = `${growthRate.toFixed(1)}%`;
        }

        return (<div className="flex justify-center items-center">
            {growthRate > 0 &&
                <TrendingUp
                    className="mr-2"
                    stroke="none"
                    size={25}
                    fill={"#00C853"}
                />
            }
            {growthRate < 0 &&
                <TrendingDown
                    className="mr-2"
                    stroke="none"
                    size={25}
                    fill={"#C10007"}
                />
            }
            {growthRate === 0 &&
                <span className="w-[25px] mr-2"></span>
            }
            {trend}
        </div>)
    };

    return (
        <div style={{ maxWidth }} className="mt-5 w-full border border-gray-200 dark:border-gray-700 rounded-lg">
            <div className="min-h-[10px]"></div>
            <span className="px-6 py-6">Activity Levels</span>
            <Row style={{ transform: `scale(${scale})`, transformOrigin: "top left" }} className="mt-5">
                <Table style={{ maxHeight }}>
                    <TableHeader className="bg-[#F7F8FA] dark:bg-gray-700 sticky top-[-5px] z-10">
                        <TableRow>
                            <TableHead className="text-[#364153] dark:text-gray-100 font-bold">District</TableHead>
                            <TableHead className="text-center text-[#364153] dark:text-gray-100 font-bold">Events</TableHead>
                            <TableHead className="text-center text-[#364153] dark:text-gray-100 font-bold">Attendees</TableHead>
                            <TableHead className="text-center text-[#364153] dark:text-gray-100 font-bold">Engagement</TableHead>
                            <TableHead className="text-center text-[#364153] dark:text-gray-100 font-bold">Trend</TableHead>
                            {/* <TableHead className="text-center text-[#364153] dark:text-gray-100 font-semibold">Status</TableHead> */}
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {activityLevels?.map((data: any) => {
                            return (
                                <TableRow key={data?.organization_population_id}>
                                    <TableCell className="font-bold">
                                        {data?.area_name}
                                    </TableCell>
                                    <TableCell className="text-center">
                                        {data?.total_events || 0}
                                    </TableCell>
                                    <TableCell className="text-center">
                                        {data?.total_attendees || 0}
                                    </TableCell>
                                    <TableCell className="text-center">
                                        {data?.avg_engagement_rate?.toFixed(2) || 0}%
                                    </TableCell>
                                    <TableCell className="text-center">
                                        {renderTrendCell(getRateGrowth(data?.organization_population_id))}
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </Row>
        </div>
    )
}
